// @ts-nocheck
import { useEffect, useState } from "react";
import { Accordion, Card, CardBody, Col, Row, Container } from "reactstrap";
import StaticLabel from "./StaticLabel";
import ExpCommonAccordionItem from "./ExpCommonAccordionItem";
import EmployeeExpView from "./EmployeeExpView";
import ExpVerticalTabContent from "./ExpVerticalTabContent";
import { getDay } from "date-fns"; // <-- make sure you import this

interface ExpenseAccordionProps {
  flushList: any;
  labels: string[];
}

const ExpenseAccordion = ({ flushList, labels }: ExpenseAccordionProps) => {
  
  const formatedData = (flushList) => {
    const fd = Object.entries(flushList || {}).map(([key, value]) => ({
      id: value.date,
      date: value.date,
      tripType: value.ExpenseTrip,
      tripLocation: value.TripLocation,
      requested: value.Requested,
      approved: value.Approved,
      audited: value.Final,
      totalFwCall: value.FW,
      totalNCA: value.NCA,
      edited: value.DoVerify ? "Edited" : "Not Edited",
      Expid: value.Expid,
      employeeId: value.employeeId,
    }));

    const newFD = fd?.map(item => {
      const getDate = new Date(item.date);
      const isSunday = getDay(getDate) === 0; // 0 => Sunday

      return {
        ...item,
        isSunday, // true or false
      };
    })

    return newFD;
  };

  const [openIds, setOpenIds] = useState<string[]>([]);
  const [formattedData, setFormattedData] = useState<any[]>([]);

  useEffect(() => {
  const data = formatedData(flushList);
  setFormattedData(data);
  const edited = data.filter((item) => item.edited === "Edited").map((item) => item.id);
  setOpenIds(edited);
  }, [flushList]);


  const toggle = (id: string | null) => {
  // ✅ Prevent toggle if id is null, undefined, or empty string
  if (!id) return;

  setOpenIds((prev) => {
    const newIds = prev.includes(id)
      ? prev.filter((openId) => openId !== id)
      : [...prev, id];
    return newIds;
  });
};

// console.log('openIds=======>',openIds);

  return (
    <Col>
      <Card>
        <CardBody>
          <Container>
            <Row className="d-flex justify-content-center align-items-center flex-nowrap">
              <Col xs="auto" className="d-flex align-items-center gap-1">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    // backgroundColor: "skyblue",
                    borderRadius: "4px",
                  }}
                ></div>
                <span style={{ color: "skyblue" }}>Holiday & Week Off</span>
              </Col>
              <Col xs="auto" className="d-flex align-items-center gap-1">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#ffcccc",
                    borderRadius: "4px",
                  }}
                ></div>
                <span style={{ color: "#ffcccc" }}>
                  Less 4 FW calls and 0 NCA
                </span>
              </Col>
              <Col xs="auto" className="d-flex align-items-center gap-1">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#ebd598",
                    borderRadius: "4px",
                  }}
                ></div>
                <span style={{ color: "#ebd598" }}>Edited Expense</span>
              </Col>
            </Row>
          </Container>

          <Accordion flush open={openIds} toggle={toggle} className="mt-4">
            <StaticLabel labels={labels} />
            <br />

            {formattedData.map((data) => (
              <ExpCommonAccordionItem
                item={data}
                key={data.id}
                accordianOpenData={openIds}
              />
            ))}
          </Accordion>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ExpenseAccordion;
